import { useRuntimeConfig, reloadNuxtApp } from '#imports';

/**
 * Load early - mounted - to allow user page tracking.
 */
export function loadRecaptcha() {
  return new Promise((resolve) => {
    const config = useRuntimeConfig()
    const captchaSiteKey = config.public.captchaSiteKey

    if (! window.grecaptcha) {
      const script = document.createElement('script')
      script.id = 'recaptcha-script'
      script.src = `https://www.google.com/recaptcha/api.js?render=${captchaSiteKey}`
      script.async = true
      script.defer = true
      document.head.appendChild(script)
    }

    resolve(true)
  })
}

/**
 * Call on form submit
 */
export async function getRecaptchaToken() {
  return new Promise(async (resolve, reject) => {
    const config = useRuntimeConfig();
    const captchaSiteKey = config.public.captchaSiteKey;

    if (! window.grecaptcha) {
      await loadRecaptcha().then(() => {
        setTimeout(() => {
          if (window.grecaptcha) {
            window.grecaptcha.execute(captchaSiteKey, {action: 'submit'})
              .then(resolve)
              .catch(reject);
          } else {
            // last resort, force reload
            reloadNuxtApp()
          }
        }, 600);
      })
    } else {
      window.grecaptcha.execute(captchaSiteKey, {action: 'submit'})
        .then(resolve)
        .catch(reject);
    }
  });
}

export function unmountRecaptcha() {
    const recaptchaScript = document.getElementById('recaptcha-script')
    if (recaptchaScript) {
      recaptchaScript.remove()
    }

    if (window.grecaptcha) {
      delete window.grecaptcha
    }

    const recaptchaBadges = document.querySelectorAll('.grecaptcha-badge')
    recaptchaBadges.forEach(badge => badge.remove())
}
